// Zentrale, einzige Quelle für die Marketing-/Werbe-Einwilligung (Hard-Gate für TikTok & Co.).
// Bewusst KEINE zweite Consent-Lösung: Terms/Privacy bleiben in lib/consent.js; hier ausschließlich
// die optionale Marketing-Einwilligung. Default = KEINE Einwilligung (Opt-in, EU/DSGVO-konform).
const KEY = "voyalyo_marketing_consent";
const EVENT = "voyalyo-marketing-consent-change";

export function hasMarketingConsent() {
  try {
    return localStorage.getItem(KEY) === "granted";
  } catch {
    return false;
  }
}

// Wird von der Cookie-/Consent-UI aufgerufen (true = zugestimmt, false = abgelehnt/widerrufen).
export function setMarketingConsent(granted) {
  try {
    localStorage.setItem(KEY, granted ? "granted" : "denied");
  } catch {
    /* Storage nicht verfügbar – Gate bleibt im Zweifel geschlossen. */
  }
  try {
    window.dispatchEvent(new CustomEvent(EVENT, { detail: { granted: !!granted } }));
  } catch {
    /* ignore */
  }
}

// True, sobald der Nutzer überhaupt eine Entscheidung getroffen hat (für Banner-Anzeige).
export function hasMarketingDecision() {
  try {
    return localStorage.getItem(KEY) != null;
  } catch {
    return false;
  }
}

// Abonniert Änderungen (liefert cleanup-Funktion). Reagiert auch auf Tab-übergreifende Änderungen.
export function onMarketingConsentChange(cb) {
  const handler = () => cb(hasMarketingConsent());
  window.addEventListener(EVENT, handler);
  window.addEventListener("storage", handler);
  return () => {
    window.removeEventListener(EVENT, handler);
    window.removeEventListener("storage", handler);
  };
}
